import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';
import ReactImageFallback from "react-image-fallback";
import Hidden from '@material-ui/core/Hidden';
import InfoContainer from "./container/InfoContainer";
import { Translation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
    generatePageURI,
    pagePaths,
    CDN_URI_BASE
} from '../common/utilities';
import styles from './collections.module.css';

export default class IndexCollection extends React.Component{

	constructor(props){
        super(props);
        
	    this.state = {
            outputList: []
            ,contentReady: false
        }
    }

    componentDidUpdate(){
        if(this.state.contentReady){
            //alert('content is ready');
        }
    }

    completedStatus(collected, total){
        return (collected >= total);
    }

    collectionSkeleton(){
        return (
            <div style={{width: '180px'}}>
                <Skeleton variant="circle" width="180px" height="180px" />
            </div>
        );        
    }

    // display collections    
    showCollections(){

        // profile index page only allows 6
        var maxOutput = 6;
        var midOutput = 4;
        var minOutput = 2;

        var string = [];

        for(var i = 0; i< maxOutput; i++){

            var currentStyle = ('N' != this.props.collections[i].completed) ?  null : styles.noprogress;
            //var currentStyle = (this.completedStatus(this.props.collections[i].user_Item_CNT, this.props.collections[i].total_Item_CNT)) ? null : styles.noprogress;
            var currentProgress = this.props.collections[i].user_Item_CNT + '/' + this.props.collections[i].total_Item_CNT;

            var output =<div className={currentStyle} key={i}>
                            <ReactImageFallback
                                src={this.props.collections[i].collection_Image}
                                fallbackImage={CDN_URI_BASE + "templates/assets/imgs/collections/collection-missing.png"}
                                alt="collection Img"
                            />                            
                            <h3>
                                {this.props.collections[i].collection_Name}
                            </h3>
                            <h5>
                                {currentProgress}
                            </h5>
                        </div>

            var itemContainer = null;

            switch (i) {
                case 0: case 1: itemContainer = <Grid item xs={12} sm={6} md={3} lg={2} xl={2} key={i}>{output}</Grid>; break;
                case 2: case 3: itemContainer = <Grid item xs={12} sm={6} md={3} lg={2} xl={2} key={i}><Hidden smDown>{output}</Hidden></Grid>; break;
                case 4: case 5: itemContainer = <Grid item xs={12} sm={6} md={3} lg={2} xl={2} key={i}><Hidden mdDown>{output}</Hidden></Grid>; break;
            };

            string.push(itemContainer);            
            // */
        }

        /*
        this.setState({
            outputList: string
            ,contentReady: true
        });
        // */
        return string;
    }


    render (){

        if(this.props.counts){

            var collectionsChild =  <div className={styles.collections}>
                                        <Grid container spacing={1}>
                                            {this.showCollections()}
                                        </Grid>
                                    </div>

            return (
                <Translation>
                    {
                        (t) => (
                        <Grid item>
                            <InfoContainer
                            headerLeft = {<Link to={generatePageURI(pagePaths.COLLECTONS)}>{t('Collections')}</Link>}
                            headerRight = {this.props.counts[0].completed_CNT + '/' + this.props.counts[0].total_CNT}
                            footer ={<Link 
                                to={generatePageURI(
                                    pagePaths.COLLECTONS
                                )}
                            >
                                {t('See All Collections')}
                            </Link>}
                            children = {collectionsChild}
                            />
                        </Grid>
                        )
                    }
                </Translation>
            );
        }else{
            return (
                <Grid item>
                    <InfoContainer
                        headerLeft = {<Link to={generatePageURI(pagePaths.COLLECTONS)}>Collections</Link>}
                        headerRight = {null}
                        footer ={<Link 
                            to={generatePageURI(
                                pagePaths.COLLECTONS
                            )}
                        >
                            See All Collections
                        </Link>}
                        children = {this.collectionSkeleton()}
                        />
                </Grid>
            );                
        }
    }
}